class PriceRangeSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListeners();
        // Sincronizza i valori degli input di testo con gli slider all'avvio
        this.syncInputs();
        this.updateSliderProgress();
    }

    addEventListeners() {
        const rangeInputvalue = this.querySelectorAll('.range-input input');
        const priceInputvalue = this.querySelectorAll('.price-input input');
        const priceGap = 50;

        priceInputvalue.forEach((input) => {
            input.addEventListener('input', (e) => {
                let minp = parseInt(priceInputvalue[0].value);
                let maxp = parseInt(priceInputvalue[1].value);
                let diff = maxp - minp;
                const maxRange = parseInt(rangeInputvalue[1].max);

                if (minp < 0) {
                    priceInputvalue[0].value = 0;
                    minp = 0;
                }
                if (maxp > maxRange) {
                    priceInputvalue[1].value = maxRange;
                    maxp = maxRange;
                }
                if (diff < priceGap) {
                    if (e.target.className === 'min-input') {
                        priceInputvalue[0].value = maxp - priceGap;
                    } else {
                        priceInputvalue[1].value = minp + priceGap;
                    }
                }

                // Sincronizzazione con gli slider
                rangeInputvalue[0].value = priceInputvalue[0].value;
                rangeInputvalue[1].value = priceInputvalue[1].value;
                this.updateSliderProgress();
            });

            // Chiamata per l'aggiornamento della griglia prodotti
            input.addEventListener('change', () => {
                const parentComponent = this.closest('xtrawine-product-grid');
                if (parentComponent && typeof parentComponent.onFilterChange === 'function') {
                    parentComponent.onFilterChange();
                }
            });
        });

        rangeInputvalue.forEach((input) => {
            input.addEventListener('input', (e) => {
                let minVal = parseInt(rangeInputvalue[0].value);
                let maxVal = parseInt(rangeInputvalue[1].value);
                let diff = maxVal - minVal;

                if (diff < priceGap) {
                    if (e.target.className === 'min-range') {
                        rangeInputvalue[0].value = maxVal - priceGap;
                    } else {
                        rangeInputvalue[1].value = minVal + priceGap;
                    }
                }

                // Sincronizzazione con gli input di testo
                priceInputvalue[0].value = rangeInputvalue[0].value;
                priceInputvalue[1].value = rangeInputvalue[1].value;
                this.updateSliderProgress();
            });

            // Chiamata per l'aggiornamento della griglia prodotti
            input.addEventListener('change', () => {
                const parentComponent = this.closest('xtrawine-product-grid');
                if (parentComponent && typeof parentComponent.onFilterChange === 'function') {
                    parentComponent.onFilterChange();
                }
            });
        });
    }

    syncInputs() {
        const rangeInput = this.querySelectorAll('.range-input input');
        const priceInput = this.querySelectorAll('.price-input input');

        if (!rangeInput || rangeInput.length < 2 || !priceInput || priceInput.length < 2) return;

        // Sincronizza i valori degli input di testo con quelli degli slider
        priceInput[0].value = rangeInput[0].value;
        priceInput[1].value = rangeInput[1].value;
    }

    updateSliderProgress() {
        const rangeInput = this.querySelectorAll('.range-input input');
        const progressElement = this.querySelector('.price-slider');

        if (!rangeInput || rangeInput.length < 2 || !progressElement) return;

        const minVal = parseInt(rangeInput[0].value);
        const maxVal = parseInt(rangeInput[1].value);
        const maxRange = parseInt(rangeInput[1].max);

        progressElement.style.left = `${(minVal / maxRange) * 100}%`;
        progressElement.style.right = `${100 - (maxVal / maxRange) * 100}%`;
    }
}

customElements.define('price-range-slider', PriceRangeSlider);
